export type ChipRadioProps = {
  name: string
  value: string
  label: string
  checked?: boolean
  onChange?: () => void
}

export function ChipRadio({
  name,
  value,
  label,
  checked,
  onChange,
}: ChipRadioProps) {
  return (
    <label className="cursor-pointer">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="peer sr-only"
      />
      <span className="inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold transition-[color,box-shadow] peer-checked:bg-foreground peer-checked:text-background peer-focus-visible:border-ring peer-focus-visible:ring-ring/50 peer-focus-visible:ring-[3px]">
        {label}
      </span>
    </label>
  )
}
